import { BannerTypes } from 'components/banner/types'
import { ELProduct, NGProduct } from 'features/simulation/types'

export enum ProducerVisual {
  MAP = 'Map',
  THREE_CHOICES = '3 Choices'
}

export enum SignChannel {
  CONFIRMATION_MAIL = 'Confirmation Mail',
  NONE = 'None',
  SIGNATURE = 'Signature'
}

export enum SimulationType {
  CONTRACT_VOLUME = 'Contract Volume',
  EAV = 'EAV',
  FIXED_AMOUNT = 'Fixed Amount',
  PRICING_SIMULATION = 'Pricing Simulation'
}

export enum MarketingDataKeys {
  ADJUSTABLE_PRODUCT = 'adjustableProduct',
  AGENT_ID = 'agentID',
  BANNER = 'banner',
  BANNER_TYPE = 'bannerType',
  CAMPAIGN_NAME = 'campaignName',
  CONFIRMATION_ROUNDUP = 'confirmationRoundup',
  EMAIL_CONFIRMATION_FLOW = 'emailConfirmationFlow',
  DEFAULT_ELECTRICITY_PRODUCT = 'defaultElectricityProduct',
  DEFAULT_GAS_PRODUCT = 'defaultGasProduct',
  EAN_CODE_MANDATORY = 'eanCodeMandatory',
  EVENT_NAME = 'eventName',
  EVENT_ID = 'eventID',
  GCLID = 'gclid',
  LEAD_SOURCE = 'leadSource',
  NO_EAN_FLOW = 'noEanFlow',
  NO_OPTIN_ONE = 'noOptinOne',
  NURTURE_FLOW = 'nurtureFlow',
  PARTNER_ID = 'partnerID',
  PRODUCER_VISUAL = 'producerVisual',
  RESET_BUTTON = 'resetButton',
  SHIFT_ID = 'shiftID',
  SIGN_CHANNEL = 'signChannel',
  SIMULATION_SO = 'simulationSo',
  SIMULATION_TYPE = 'simulationType',
  SOURCE_TYPE = 'sourceType',
  TRIGGER_EVENTS = 'triggerEvents'
}

export type MarketingStore = {
  [MarketingDataKeys.ADJUSTABLE_PRODUCT]: boolean
  [MarketingDataKeys.AGENT_ID]: string
  [MarketingDataKeys.BANNER]?: string
  [MarketingDataKeys.BANNER_TYPE]: BannerTypes | ''
  [MarketingDataKeys.CAMPAIGN_NAME]: string
  [MarketingDataKeys.CONFIRMATION_ROUNDUP]: boolean
  [MarketingDataKeys.EMAIL_CONFIRMATION_FLOW]: boolean
  [MarketingDataKeys.DEFAULT_ELECTRICITY_PRODUCT]: ELProduct
  [MarketingDataKeys.DEFAULT_GAS_PRODUCT]: NGProduct
  [MarketingDataKeys.EAN_CODE_MANDATORY]: boolean
  [MarketingDataKeys.EVENT_NAME]?: string
  [MarketingDataKeys.EVENT_ID]?: string
  [MarketingDataKeys.GCLID]: string
  [MarketingDataKeys.LEAD_SOURCE]: string
  [MarketingDataKeys.NO_EAN_FLOW]: boolean
  [MarketingDataKeys.NO_OPTIN_ONE]: boolean
  [MarketingDataKeys.NURTURE_FLOW]: string
  [MarketingDataKeys.PARTNER_ID]: string
  [MarketingDataKeys.PRODUCER_VISUAL]: ProducerVisual
  [MarketingDataKeys.RESET_BUTTON]: boolean
  [MarketingDataKeys.SHIFT_ID]: string
  [MarketingDataKeys.SIGN_CHANNEL]: SignChannel
  [MarketingDataKeys.SIMULATION_SO]: string
  [MarketingDataKeys.SIMULATION_TYPE]: SimulationType
  [MarketingDataKeys.SOURCE_TYPE]: string
  [MarketingDataKeys.TRIGGER_EVENTS]: string
}
